import './shared/rxjs-operators';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './layout/layout.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { RootAuthGuard } from './guards/root-auth.guard';
import { OnlyLoggedInUsersGuard } from './guards/only-loggedin-users.guard';
import { AlwaysAuthChildrenGuard } from './guards/always-auth-children.guard';
import { DeactivateGuard } from './guards/deactivate.guard';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor, TimingLogInterceptor, ResponseErrorInterceptor } from './http.interceptor';
import { SCECoreModule, ResourceService } from 'sce-core';
import { SCESearchModule } from 'sce-search';
import { SCEAdminModule } from 'sce-admin';
import { SCEUILibraryModule } from 'sce-ui-lib';
import { isScreenAccess } from './guards/is-screen-access';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    // -- import Library modules
    SCECoreModule.forRoot(),
    SCEAdminModule.forRoot(),
    SCEUILibraryModule.forRoot(),
    SCESearchModule,
    // -- END import Library modules
    CoreModule, /* Provides core services across the app. Only import in AppModule */
    LayoutModule, /* Root Layout declarations. Home/Login components only */
    SharedModule.forRoot(), /* Shared components/pipes/directives for the app */
    HttpClientModule /*New HttpClient only available from angular 4.3+. */
  ],
  providers: [
    RootAuthGuard,
    OnlyLoggedInUsersGuard,
    isScreenAccess,
    AlwaysAuthChildrenGuard,
    DeactivateGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TimingLogInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseErrorInterceptor, multi: true },
    ResourceService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/app.module.ts